const websiteLocales = ["ro", "en", "hu"];

export default function returnLocale(locale: string) {
  if (websiteLocales.includes(locale.toLowerCase())) {
    return locale;
  } else return "en";
}
